module.exports = __webpack_public_path__ + "img/t2.9e3b4d32.svg";